import React from "react";
import { useTranslation } from "react-i18next";
import { CSVLink } from "react-csv";
import InputComponent from "../_common/inputComponent";
import PaginationOwn from "../_common/ownPagination";

const ReportStoreTable = (props) => {
  const { t } = useTranslation();
  const headers = [
    { label: t("admin.reports.venueName"), key: "storeName" },
    { label: t("admin.reports.venueAddress"), key: "address" },
    { label: t("admin.reports.venuePostcode"), key: "storePostalCode" },
    { label: t("admin.reports.venueZone"), key: "zone" },
    { label: t("admin.reports.totalProductsCollected"), key: "count" },
  ];
  return (
    <>
      {/* <div className="pt-4 admin-controls">
        <form
          onSubmit={(ev) => // eslint-disable-next-line
            
            props?.searchFunc(ev, props?.searchVal)}
          className="col-12 col-lg-6 admin-search"
        >
          <div className="search-wrapper">
            <InputComponent
              placeholder={t("admin.reports.searchVenue")}
              label={t("admin.reports.searchVenue")}
              type="text"
              name="search"
              theme="admin"
              value={props?.searchVal}
              handleCallback={(val) => {
                // eslint-disable-next-line
                props?.setSearchVal(val);
              }}
            />
          </div>
          <button type="submit" className="btn secondary-btn">
            {t("common.go")}
          </button>
        </form>
          <div className="download-btn col-12 col-lg-6 d-flex justify-content-start justify-content-lg-end align-items-center mt-3 mt-lg-0">
            <CSVLink
              className="btn admin-btn secondary-btn"
              data={props?.allReport}
              filename={"store-report.csv"}
              headers={headers}
            >
              {t("common.downloadCsv")}
            </CSVLink>
            {props?.reportData?.length > 0 && (
              <div className="px-3 col-12 pt-3">
                <PaginationOwn
                  pageSize={props?.pageSize}
                  changePageSize={props?.changePageSize}
                  goToPage={props?.goToPage}
                  totalCount={props?.totalCount}
                  currentPage={props?.currentPage}
                  applicationType={props?.applicationType}
                  paginationType="report"
                />
              </div>
            )}
          </div>
      </div> */}
      <div className="container-fluid">
  <div className="row form-report my-2">
    <div className="col-12 mt-4">
      <div className="row admin-controls">
        {/* Search */}
        <form
          onSubmit={(ev) => // eslint-disable-next-line
            
            props?.searchFunc(ev, props?.searchVal)}

          className="col-12 col-lg-6 admin-search"
        >
          <div className="search-wrapper">
            <InputComponent
              placeholder={t("admin.reports.searchVenue")}
              label={t("admin.reports.searchVenue")}
              type="text"
              name="search"
              theme="admin"
              value={props?.searchVal}
              handleCallback={(val) => {
                // eslint-disable-next-line
                props?.setSearchVal(val);
              }}
            />
          </div>

          <button type="submit" className="btn secondary-btn">
            {t("common.go")}
          </button>
        </form>

        {/* Add Button */}
        <div className="row">
          {/* Button */}
          <div className="col-12 mb-3 mt-4">
            <CSVLink
                      className="btn secondary-btn modal-btn"
                      data={props?.allReport}
                      filename={"store-report.csv"}
                      headers={headers}
                    >
                      {t("common.downloadCsv")}
                    </CSVLink>
          </div>

          {/* Table */}
          <div className="report-table-wrapper col-lg-8 col-md-12">
            <p className="report-type fs-4">{t("admin.reports.condomsPerVenue")}</p>

            <div className="table-wrapper-scroll-y table-scrollbar">
              <div className="table-responsive table-own">
                <table className="table table-hover table-admin">
                  <thead className="table-head">
                    <tr>
                      <th
                        className={`sort-header cursor ${
                          props?.sortObj.sortVal === "storeName" ? "active" : ""
                        } ${props?.sortObj.sortType ? "aesc" : "desc"}`}
                        onClick={() => props?.arraySorting("storeName")}
                      >
                        <span>{t("admin.reports.venueName")}</span>
                      </th>

                      <th
                        className={`sort-header cursor ${
                          props?.sortObj.sortVal === "address" ? "active" : ""
                        } ${props?.sortObj.sortType ? "aesc" : "desc"}`}
                        onClick={() => props?.arraySorting("address")}
                      >
                        <span>{t("admin.reports.venueAddress")}</span>
                      </th>

                      <th
                        className={`sort-header cursor ${
                          props?.sortObj.sortVal === "storePostalCode"
                            ? "active"
                            : ""
                        } ${props?.sortObj.sortType ? "aesc" : "desc"}`}
                        onClick={() => props?.arraySorting("storePostalCode")}
                      >
                        <span>{t("admin.reports.venuePostcode")}</span>
                      </th>

                      <th
                        className={`sort-header cursor ${
                          props?.sortObj.sortVal === "zone" ? "active" : ""
                        } ${props?.sortObj.sortType ? "aesc" : "desc"}`}
                        onClick={() => props?.arraySorting("zone")}
                      >
                        <span>{t("admin.reports.venueZone")}</span>
                      </th>

                      <th
                        className={`sort-header cursor ${
                          props?.sortObj.sortVal === "count" ? "active" : ""
                        } ${props?.sortObj.sortType ? "aesc" : "desc"}`}
                        onClick={() => props?.arraySorting("count")}
                      >
                        <span>{t("admin.reports.totalProductsCollected")}</span>
                      </th>
                    </tr>
                  </thead>

                  <tbody className="table-body">
                    {props?.reportData?.map((data, index) => (
                      <tr key={index}>
                        <td>{data.storeName}</td>
                        <td>{data.address}</td>
                        <td>{data.storePostalCode}</td>
                        <td>{data.zone}</td>
                        <td>{data.count}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Stats */}
          <div className="reports-stats-wrapper col-lg-4 col-md-12">
            <p className="report-type fs-4">
              {t("admin.reports.totalsPerDateRange")}
            </p>

            <div className="reports-stats">
              <ul className="list-unstyled">
                <li className="list-group-item list-group-item-success d-flex justify-content-between report-data">
                  <span>{t("admin.reports.storesAdded")}</span>
                  <span>{props?.totalStats?.storesAdded}</span>
                </li>

                <li className="list-group-item list-group-item-primary d-flex justify-content-between report-data">
                  <span>{t("admin.reports.kioskAdded")}</span>
                  <span>{props?.totalStats?.ivtsAdded}</span>
                </li>

                <li className="list-group-item list-group-item-warning d-flex justify-content-between report-data">
                  <span>{t("admin.reports.newUsers")}</span>
                  <span>{props?.totalStats?.newUsers}</span>
                </li>

                <li className="list-group-item list-group-item-primary d-flex justify-content-between report-data">
                  <span>{t("admin.reports.activeUsers")}</span>
                  <span>{props?.totalStats?.activeUsers}</span>
                </li>

                <li className="list-group-item list-group-item-danger d-flex justify-content-between report-data">
                  <span>{t("admin.reports.totalCondomsCollected")}</span>
                  <span>{props?.totalStats?.totalCondomsCollected}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</div>
      
    </>
  );
};

export default ReportStoreTable;
